import BaseModel from './BaseModel';
import {ATTRIBUTE_TYPES, HitContainerAttribute} from '../../components';
import {HitOnlineEnums} from 'hit-online-web-ui/src/helpers/constants';
import {translate} from '../../plugins/i18n/i18n';
import Staff from './Staff';
import FileDocument from './FileDocument';
import QmDocument from './QmDocument';

export default class QmDocumentHistory extends BaseModel {
  constructor({
    id,
    staff = undefined,
    document = undefined,
    qm_document = undefined,
    operation = undefined,
    date = undefined,
  }) {
    super(id, undefined, undefined);
    this.staff = staff ? new Staff(staff) : null;
    this.document = document ? new FileDocument(document) : null;
    this.qm_document = qm_document ? new QmDocument(qm_document) : null;
    this.operation = operation
      ? HitOnlineEnums.getEnumValue(
          'QM_DOCUMENT_HISTORY_OPERATION',
          operation,
          translate
        )
      : null;
    this.date = date;
  }

  static get fkNameDocument() {
    return 'document_id';
  }

  get fkNameDocument() {
    return QmDocumentHistory.fkNameDocument;
  }

  static get fkNameQmDocument() {
    return 'qm_document_id';
  }

  get fkNameQmDocument() {
    return QmDocumentHistory.fkNameQmDocument;
  }

  //   No need as the user will see it in a modal

  //   get detailPageRoute() {
  //     return QmDocument.detailPageRoute;
  //   }

  //   static get detailPageRoute() {
  //     return 'qmDocumentDetail';
  //   }

  static get apiRoute() {
    return 'qm_document_history';
  }

  static get listPageRoute() {
    return 'QmDocumentHistoryDetail';
  }

  get apiRoute() {
    return QmDocumentHistory.apiRoute;
  }

  static get joinAttrsKey() {
    return ['staff', 'document', 'operation', 'date'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes([
      'staff',
      'document',
      'version',
      'operation',
      'date',
    ]);
  }

  static get detailAttrs() {
    return this.getAttributes(['staff', 'document', 'operation', 'date']);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['staff', 'document', 'operation', 'date']);
  }

  static get allAttributes() {
    return {
      staff: new HitContainerAttribute(ATTRIBUTE_TYPES.FK_STAFF, {
        joinPath: ['staff!fk_qm_document_history_staff_id_staff'],
        tableProperties: {
          header: 'hit-app.common.staff-member',
          maxWidth: '2fr',
        },
      }),
      document: new HitContainerAttribute(ATTRIBUTE_TYPES.FK_FILE_DOCUMENT, {
        joinPath: ['document!fk_qm_document_history_document_id_document'],
        fkToUpdate: 'document_id',
        tableProperties: {
          header: 'hit-app.common.document',
          maxWidth: '2fr',
        },
      }),
      version: new HitContainerAttribute(ATTRIBUTE_TYPES.NOT_FETCHED, {
        tableProperties: {
          header: 'hit-app.common.version',
          maxWidth: '1fr',
        },
        transform: (data) => {
          return data?.document?.version;
        },
      }),
      qm_document: new HitContainerAttribute(ATTRIBUTE_TYPES.FK_QM_DOCUMENT, {
        joinPath: [
          'qm_document!fk_qm_document_history_qm_document_id_qm_document',
        ],
        fkToUpdate: 'qm_document_id',
        tableProperties: {
          header: 'hit-app.common.designation',
          maxWidth: '2fr',
        },
      }),
      operation: new HitContainerAttribute(ATTRIBUTE_TYPES.ENUMERATION, {
        enumType: 'QM_DOCUMENT_HISTORY_OPERATION',
        tableProperties: {
          header: 'hit-app.common.operation',
          maxWidth: '1fr',
        },
      }),
      date: new HitContainerAttribute(ATTRIBUTE_TYPES.DATETIME, {
        tableProperties: {
          header: 'hit-app.common.date',
          maxWidth: '1fr',
        },
      }),
      // user: new HitContainerAttribute(ATTRIBUTE_TYPES.NOT_FETCHED, {
      //   readOnly: true,
      //   tableProperties: {
      //     header: 'hit-app.common.staff-member',
      //     maxWidth: '2fr',
      //     readOnly: true,
      //     },
      //   transform: (data) => {
      //     return data.staff.first_name + ' ' + data.staff.last_name;
      //   },
      //   }
      // ),
    };
  }
}
